import { $authHost } from '.';
import { GetTicketsResponse } from '@/@types/tickets.types';

export async function getTickets() {
  const response = await $authHost.request<GetTicketsResponse>({
    url: '/tickets',
  });
  return response;
}
